/**************************************************************************
 * Created on Tue Aug 27 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import { useEffect, useState } from "react";
import axios from "axios";
import { PageHeading } from "../header-n-footer/page-heading/page-heading";
import Banner from "../../dashboard/banner";
import MaintenanceBanner from "../maintenance-banner/maintenance-banner";
import { IMainLayout } from "../model/app-layout";
import { ReactComponent as SVGBell } from './bell.svg'
import './index.scss';
import { useDssContext } from "../../../DSSContext";
import { notifyError } from "../../../ui/dls/dls-snackbar/dls-snackbar";
import BreadCrumb from "../../dashboard/breadcrumb";
import { MENUPOSITION } from "../../dashboard/model";
import Header from "../header-n-footer/header/header";
import { FooterLayout } from "../header-n-footer/footer/footer-layout";
import { useLocation } from "react-router-dom";

export const MainLayout = ({ children }: IMainLayout): JSX.Element =>
{


    return (
        <>
            { <PageHeading  /> }
        
            <div className="main-contianer">
                { children }
            </div>
            {  <FooterLayout /> }
        </>

    );
};